import LegalShell from '../components/layout/LegalShell';

export default function Privacy() {
  return (
    <LegalShell eyebrow="Información legal" title="Política de privacidad">
      <div className="legal-notice" role="note">
        Documento pendiente de revisión y de completar con los datos reales de
        la responsable antes de publicar la web.
      </div>

      <section>
        <h2>1. Responsable del tratamiento</h2>
        <p>
          <strong>Responsable:</strong> [RAZÓN SOCIAL PENDIENTE]
          <br />
          <strong>NIF:</strong> [NIF PENDIENTE]
          <br />
          <strong>Domicilio:</strong> [DOMICILIO PENDIENTE]
          <br />
          <strong>Contacto:</strong> [EMAIL PENDIENTE]
        </p>
      </section>

      <section>
        <h2>2. Datos tratados y finalidad</h2>
        <p>
          Los datos enviados mediante el cuestionario se utilizarán únicamente
          para revisar la solicitud, comprender las necesidades expresadas y
          contactar con la persona interesada. El formulario solicita datos de
          contacto y respuestas relacionadas con sus objetivos y circunstancias.
        </p>
      </section>

      <section>
        <h2>3. Base jurídica</h2>
        <p>
          El tratamiento se basa en el consentimiento que se solicita antes de
          enviar el cuestionario. El envío es voluntario y el consentimiento
          puede retirarse contactando con [EMAIL PENDIENTE].
        </p>
      </section>

      <section>
        <h2>4. Conservación y destinatarios</h2>
        <p>
          Los datos se conservarán durante [PLAZO DE CONSERVACIÓN PENDIENTE] y
          no se cederán a terceros salvo obligación legal. Para prestar el
          servicio técnico podrán intervenir proveedores de infraestructura y
          almacenamiento, cuya relación y garantías deben revisarse antes de la
          publicación definitiva.
        </p>
      </section>

      <section>
        <h2>5. Derechos</h2>
        <p>
          Puedes solicitar el acceso, rectificación, supresión, limitación,
          oposición o portabilidad de tus datos escribiendo a [EMAIL PENDIENTE].
          También puedes presentar una reclamación ante la autoridad de control
          competente.
        </p>
      </section>

      <section>
        <h2>6. Cookies y medición</h2>
        <p>
          Esta web utiliza Google Analytics 4 y Microsoft Clarity para medir las
          visitas y el uso de la web, analizar la navegación y la interacción,
          detectar puntos de abandono y mejorar el rendimiento y la experiencia
          de usuario.
        </p>
        <p>
          No enviamos a estas herramientas el nombre, correo electrónico,
          teléfono, usuario de Instagram ni las respuestas abiertas del
          cuestionario. Los datos de contacto enviados mediante el formulario se
          gestionan a través del sistema actual del formulario y no se utilizan
          como eventos de analítica. El cuestionario está excluido y enmascarado
          en Microsoft Clarity para evitar que se capture la información
          introducida por la persona usuaria.
        </p>
      </section>
    </LegalShell>
  );
}
